import { initServices } from "@sushicorp/services";
import { DEFAULT_API_URLS } from "@sushicorp/utils";

import { getAuth } from "./artisn.config";
import { queryClient } from "./reactQuery.config";
import CONSTANTS from "config/constants";
import { shouldMock } from "utils/common.utils";

const { GENERAL, API, ARTISN } = CONSTANTS;
const { PLATFORM } = GENERAL;
const { ACCOUNT_ID } = ARTISN;
const { MOCK_WITH_INITIAL_USER_DATA } = API;

const API_URL = DEFAULT_API_URLS[ACCOUNT_ID];

initServices({
  platform: PLATFORM,
  accountId: ACCOUNT_ID,
  shouldMock,
  queryClient,
  mockWithInitialUserData: MOCK_WITH_INITIAL_USER_DATA,
  auth: getAuth,
  apiUrl: API_URL
});
